module.exports = __webpack_public_path__ + "static/img/buy_juese_active.4459e853.png";